import Languages from '../languages';

import * as utils from '@store/ultile';

import globalConfig from '@utiles/globalConfig';
import { LANGUAGE_LOCALSTORGE_NAME } from '@store/languages';

// 2021.2.22 这段限制语言导致其他页面的语言设置有问题
// let languagePreset = ['zh-CN', 'zh-TW', 'en-US', 'vi-VN', 'th-TH', 'ko-KR']

let curLanguage =
  utils.getHrefParam('language') ||
  globalConfig.getLclStorageItem(LANGUAGE_LOCALSTORGE_NAME) ||
  'en-US';
let curAppLanguage =
  utils.getHrefParam('appLanguage') ||
  globalConfig.getLclStorageItem(LANGUAGE_LOCALSTORGE_NAME) ||
  'en-US';
// curLanguage = languagePreset.indexOf(curLanguage) > -1 ? curLanguage : 'en-US'
// curAppLanguage = languagePreset.indexOf(curAppLanguage) > -1 ? curAppLanguage : 'en-US'

Languages.init();
// Languages.setLanguage(curLanguage)

export const state = {
  gameId: utils.getHrefParam('gameId') || '',
  language: Languages.getAll(),
  curLanguage,
  curAppLanguage,
  user_account: '',
  quest: {
    list: [],
  },
  area: {
    list: [],
  },
  addOptions: null,
  repairOptions: {
    result: null,
    data: {
      auth: null,
      user_pass_timeout: null,
    },
  },
  curProcess: null,
  applyResult: {
    msg: null,
    bill_number: null,
    pwd: null,
    result: null,
  },
  queryResult: {
    msg: null,
    reply: null,
    reason: null,
    user_pass_timeout: null,
    auth: {
      password: null,
      email: null,
      question: null,
    },
    result: null,
  },
  addResult: {
    msg: null,
    result: null,
  },
  emailSendStatus: {
    msg: null,
  },
  resetPwdStatus: {
    result: 0,
    data: null,
    msg: null,
  },
  resetEmailStatus: {
    result: 0,
    data: null,
    msg: null,
  },
  resetQuestStatus: {
    result: 0,
    data: null,
    msg: null,
  },
  dialogs: {
    status: null,
    text: null,
  },
};
